import { Divider, styled } from '@mui/material'
import { useEffect, useState } from 'react'
import AdAccountTable from 'src/components/adminAccount/AdAccountTable'
import { LoadAccount } from 'src/components/adminAccount/useLoadAccount'
import { useAdAccountStore } from 'src/stores/AdAccountStore'

const PageWrapper = styled('div')(({theme})=>({
  margin : '30px 30px',
  backgroundColor:'white',
  borderRadius:'10px',
  height: 'calc(100vh - 126px)', // 필요시 조정
  overflow: 'hidden', // 전체적으로 overflow 방지
}))

const StatusWrapper = styled('div')(({theme})=>({
  display: 'flex',
  justifyContent:'space-around',
  alignItems:'center',

  width:'100%'
}))

const StatusContainer = styled('button',{
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: boolean }>(({ theme, status })=>({
  all:'unset',
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  gap:'10px',
  
  width:'100%',
  padding:'21.5px',
  position:'relative',
  cursor:'pointer',
  color: status ? '#30515B' : '#AAAAAA',
  fontSize:'18px',
  fontWeight:'bold',
  whiteSpace:'nowrap'
}))

const Dividersx ={
  width: '90%', 
  height: '2px', 
  backgroundColor: '#30515B', 
  bottom:0, 
  position:'absolute'
}

const CountWrapper = styled('div',{
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: boolean }>(({ theme, status })=>({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',

  color:'white',
  backgroundColor: status ? '#30515B' : '#AAAAAA',
  padding:'4px 14px',
  borderRadius:'100px',
  fontSize:'16px',
  fontWeight:'bold',

  height: '27px', // ✅ 명확하게 height 지정
  lineHeight: '27px', // ✅ 텍스트 기준선을 정확히 가운데로
  boxSizing: 'border-box',
}))

const TableWrapper = styled('div')(({theme})=>({
  padding: '30px 20px'
}))

export type statusType = '전체' | '승인' | '대기' | '차단'

const AdAccountPage = () => {
  const [status, setStatus] = useState<statusType>('전체')
  const data = useAdAccountStore((state)=>state.data)
  const setField = useAdAccountStore((state)=>state.setField)
  const reset = useAdAccountStore((state)=>state.reset)
  const page = useAdAccountStore((state)=>state.page)
  const pageSize = useAdAccountStore((state)=>state.pageSize)
  const statusField = useAdAccountStore((state)=>state.status)
  const totalCount = useAdAccountStore((state)=>state.totalCount)
  const approveCount = useAdAccountStore((state)=>state.approveCount)
  const pendingCount = useAdAccountStore((state)=>state.pendingCount)
  const inactiveCount = useAdAccountStore((state)=>state.inactiveCount)

  const fetchData = async () => {
    const result = await LoadAccount(statusField,page,pageSize);
    setField('data',result.data)
    setField('totalpage',result.totalPage)
    setField('totalCount',result.totalCount)
    setField('approveCount',result.approved)
    setField('pendingCount',result.pending)
    setField('inactiveCount',result.inactive)
  }

  useEffect(()=>{
    fetchData()
  },[page,statusField])
  useEffect(()=>{
    return()=>{
      reset()
    }
  },[])

  const statusCounts = {
    전체: totalCount,
    승인: approveCount,
    대기: pendingCount,
    차단: inactiveCount
  };

  const onClickStatus = (status:statusType)=>{
    setStatus(status)
    const convertStatus = {
      전체: 'all',
      승인: 'approved',
      대기: 'pending',
      차단: 'inactive',
    }[status];
    setField('status',convertStatus)
    setField('page', 1); // ✅ 탭 변경 시 페이지 초기화
  }

  return (
    <PageWrapper>
      <StatusWrapper>
        <StatusContainer status={status === '전체'} onClick={()=>onClickStatus('전체')}>전체 <CountWrapper status={status === '전체'}>{statusCounts['전체']}</CountWrapper>{status === '전체' && <Divider sx={Dividersx}/>}</StatusContainer>
        <StatusContainer status={status === '승인'} onClick={()=>onClickStatus('승인')}>승인 <CountWrapper status={status === '승인'}>{statusCounts['승인']}</CountWrapper>{status === '승인' && <Divider sx={Dividersx}/>}</StatusContainer>
        <StatusContainer status={status === '대기'} onClick={()=>onClickStatus('대기')}>대기 <CountWrapper status={status === '대기'}>{statusCounts['대기']}</CountWrapper>{status === '대기' && <Divider sx={Dividersx}/>}</StatusContainer>
        <StatusContainer status={status === '차단'} onClick={()=>onClickStatus('차단')}>차단 <CountWrapper status={status === '차단'}>{statusCounts['차단']}</CountWrapper>{status === '차단' && <Divider sx={Dividersx}/>}</StatusContainer>
      </StatusWrapper>
      <TableWrapper>
        <AdAccountTable propsData={data} status={status}/>
      </TableWrapper>
    </PageWrapper>
  )
}

export default AdAccountPage